import React from 'react'

import * as S from './visitor-parking-form-layout.styled'

interface VisitorParkingFormLayoutProps {
  children: React.ReactNode
  footer: React.ReactNode
}

const VisitorParkingFormLayout = ({ children, footer }: VisitorParkingFormLayoutProps) => {
  return (
    <S.Container>
      <S.ScrollContainer>
        <S.Content>
          {children}
          <S.BottomSpace />
        </S.Content>
      </S.ScrollContainer>
      <S.Footer>{footer}</S.Footer>
    </S.Container>
  )
}

export { VisitorParkingFormLayout }
